import React, { useEffect, useState } from 'react';
import { Menu, X, Heart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: "What's Included",
    href: '#included'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-cream'}`} data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="flex justify-between items-center h-16 sm:h-20" data-id="element-222">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-223">
            <div className="bg-primary/10 p-2 rounded-xl" data-id="element-224">
              <Heart className="h-6 w-6 text-primary fill-primary/20" data-id="element-225" />
            </div>
            <span className="font-heading font-bold text-xl sm:text-2xl text-dark tracking-tight" data-id="element-226">
              Small Big Emotions
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-227">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-muted hover:text-primary font-medium transition-colors" data-id="element-228">
                {link.name}
              </a>)}
            <a href="#cta" className="bg-primary hover:bg-primary/90 text-white px-6 py-2.5 rounded-full font-bold transition-all hover:shadow-warm hover:-translate-y-0.5" data-id="element-229">
              Get It Now — 50% Off
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-230">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-dark p-2" aria-label="Toggle menu" data-id="element-231">
              {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-232" /> : <Menu className="h-6 w-6" data-id="element-233" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-234">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-235">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-236">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-4 text-base font-medium text-dark hover:bg-peach/50 rounded-xl" data-id="element-237">
                  {link.name}
                </a>)}
              <div className="pt-4 px-3" data-id="element-238">
                <a href="#cta" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-primary text-white px-6 py-3 rounded-full font-bold shadow-warm" data-id="element-239">
                  Get It Now — 50% Off
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}